import React, { useRef, useEffect, useState, useContext } from "react";
import analyticstracker from "@jmc/analyticstracker";
import { useCookieInteraction } from "@jmc/core/src/hooks/useCookieInteraction/index";
import { EventTypes } from "@jmc/core/src/types/EventTypes";
import cleanCSSIdentifier from "@jmc/utils/utils/clean-css-identifier";
import { CarouselContext } from "pure-react-carousel";
import { useOnScreen } from "@jmc/utils/hooks/useOnScreen";

type Props = {
    children: JSX.Element | React.ReactNode;
    name: string;
    position: number;
    type: string;
    placement: string;
};

export const CarouselSlideTracking = (props: Props): JSX.Element => {
    const { interacted } = useCookieInteraction();
    const { name, type, placement, position, children } = props;
    const ref = useRef<HTMLDivElement>(null);
    const inViewport = useOnScreen(ref);

    const carouselContext = useContext(CarouselContext);
    const [carouselState, setCarouselState] = useState(carouselContext);
    const [isSent, setSend] = useState(false);

    useEffect(() => {
        if (carouselState.state.currentSlide === position && !isSent && interacted && inViewport) {
            setSend(true);
            analyticstracker().trackEvent({
                event: EventTypes.CONTENTBLOCK_IMPRESSION,
                info: {
                    name: name,
                    position: position + 1,
                    type: type,
                    placement: placement,
                },
            });
        }
    }, [carouselState, interacted, inViewport]);

    useEffect(() => {
        const onChange = (): void => {
            setCarouselState({ ...carouselContext });
        };

        carouselContext.subscribe(onChange);
        return () => carouselContext.unsubscribe(onChange);
    }, [carouselContext]);

    return (
        <div
            style={{ height: "100%", width: "100%" }}
            ref={ref}
            id={cleanCSSIdentifier(`content-block-impression-${position}-${name}-${placement}`)}
        >
            {children}
        </div>
    );
};

export default CarouselSlideTracking;
